import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'abp-layout-empty',
  template: `
    <router-outlet></router-outlet>
    <abp-confirmation></abp-confirmation>
    <abp-toast-container></abp-toast-container>
  `,
})
export class EmptyLayoutComponent {}